import { createStandaloneToast } from '@chakra-ui/react';
import theme from '_app/theme';

const standaloneToast = createStandaloneToast(theme);
const toast = params =>
  standaloneToast({
    isClosable: true,
    position: 'top-right',
    ...params,
  });

export default toast;
